import { find } from 'lodash';

import actionTypes from 'constants/action-types';
import { CHOROPLETH_TOPOJSON_TYPES } from 'constants/geospatial';
import { topojsonPropertyIndex, topojsonToGeojson } from 'utils/topojson';

const initialState = {};

function topology(state = initialState, { type, payload }) {
  switch (type) {
    case actionTypes.CACHE.UPSERT_TOPOJSON:
      const { name, json } = payload;
      const { properties } = find(CHOROPLETH_TOPOJSON_TYPES, { name }) || {};
      if (properties === undefined) {
        return state;
      }

      return {
        ...state,
        [name]: {
          geoJSON: topojsonToGeojson(json),
          index: topojsonPropertyIndex(json, properties),
        },
      };
    default:
      return state;
  }
}

export default topology;
export { topology };
